import styled from "@emotion/styled"

const BlogListNavigationWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 15px;
`

export default BlogListNavigationWrapper
